import { GetProductListData, GetProductListResponse } from "services/interface";
import styled from "@emotion/styled";
import { Row, Space, Tag } from "antd";
import NotFoundData from "components/NotFoundData";
import React, { Dispatch, FC, SetStateAction, useEffect } from "react";
import ProductCard from "../ProductCard";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";
import SearchProductForm from "../SearchProductForm";

const { CheckableTag } = Tag;

/** แท็กที่ยังไม่เลือกให้พื้นหลังขาว (พื้นหลังหน้าเป็น #efefef) */
const ChannelCheckableTag = styled(CheckableTag)`
  &:not(.ant-tag-checkable-checked) {
    background-color: #ffffff !important;
    border-color: #d9d9d9;
  }
`;

export type ProductChannelFilter = "platform" | "ext";

interface ProductOnSaleProps {
  isLoading: boolean;
  data: GetProductListResponse | undefined;
  refetch: () => void;
  refetchTo: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string;
  channelFilter?: ProductChannelFilter;
  onChannelFilterChange?: (value: ProductChannelFilter) => void;
}

const ProductOnSale: FC<ProductOnSaleProps> = ({
  isLoading,
  data,
  refetch,
  refetchTo,
  setSearchInput,
  searchInput,
  channelFilter,
  onChannelFilterChange,
}) => {

  const dispatch = useAppDispatch();

  const [productSort , setProductSort] = React.useState<GetProductListData[]>([]);


  useEffect(() => {
    dispatch(setLoading(isLoading));
    // unmount → ล้าง overlay ทันที (กัน backdrop ค้างเมื่อ component ถูก unmount ระหว่างโหลด)
    return () => { dispatch(setLoading(false)); };
  }, [isLoading, dispatch]);

  useEffect(() => {
    if (data) {
      // sort product by name
      const sortedProduct = data.products?.sort((a, b) => a.name.localeCompare(b.name));
      setProductSort(sortedProduct);
    }
  }, [data]);

  const showChannelFilter =
    onChannelFilterChange != null && channelFilter != null;

  const channelFilterTags = showChannelFilter ? (
    <ChannelFilterRow>
      <Space size={[8, 8]} wrap>
        <ChannelCheckableTag
          checked={channelFilter === "platform"}
          onChange={(checked) => {
            if (checked) onChannelFilterChange("platform");
          }}
        >
          ขายผ่านแบ่งเบา แพลทฟอร์ม
        </ChannelCheckableTag>
        <ChannelCheckableTag
          checked={channelFilter === "ext"}
          onChange={(checked) => {
            if (checked) onChannelFilterChange("ext");
          }}
        >
          ขายผ่าน Ext. API (Line , Web)
        </ChannelCheckableTag>
      </Space>
    </ChannelFilterRow>
  ) : null;

  //ยังไม่มีสินค้าในตอนนี้
  if (!data || data.products?.length === 0) {
    return  <WrapperAll> 
              <SearchProductFormWrapper>
                <SearchProductForm searchInput={searchInput} setSearchInput={setSearchInput} />
              </SearchProductFormWrapper>
              {/* {channelFilterTags} */}
              <NotFoundData text="ยังไม่มีสินค้าในตอนนี้" />
            </WrapperAll>;  }

  return (
    <WrapperAll>
      <SearchProductFormWrapper>
          <SearchProductForm searchInput={searchInput} setSearchInput={setSearchInput}/>
          {/* <Button>สร้างแท็ก</Button> */}
      </SearchProductFormWrapper>
      {/* {channelFilterTags} */}

      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >

      { data && productSort.map((item) => {
        return (
          <ProductCard
            key={item.id}
            data={item}
            refetch={refetch}
            refetchTo={refetchTo}
          />
        );
      })}
      </Row>
    </WrapperAll>
  );
};

export default ProductOnSale;

const WrapperAll = styled.div`
  padding: 10px 0px 0px 0px;
  background-color: #efefef;
`;

const SearchProductFormWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ChannelFilterRow = styled.div`
  padding: 8px 0 12px 0;
`;